
angular.module('bmsApp.training').factory('TrainingRecordSvc', function (CRUDSvc, TRAINING_RECORD_API) {

	return {
		allEmployeesCalendar: function (params) {
			return CRUDSvc.get(TRAINING_RECORD_API.ALL_EMPLOYEES_CALENDAR, params);
		},
		calendarEvents: function (params) {
			return CRUDSvc.get(TRAINING_RECORD_API.CALENDAR_EVENTS, params);
		},
		byEmployee: function (employeeId, params) {
			var newParams = angular.extend({}, params, {
				filter: {
					employee: employeeId
				}
			});
			return CRUDSvc.get(TRAINING_RECORD_API.INDEX, newParams);
		},
		create: function (trainingRecord) {
			return CRUDSvc.post(TRAINING_RECORD_API.CREATE, trainingRecord);
		},
		update: function (id, trainingRecord) {
			return CRUDSvc.post(TRAINING_RECORD_API.UPDATE + id, trainingRecord);
		},
		delete: function (id) {
			return CRUDSvc.get(TRAINING_RECORD_API.DELETE + id);
		}
	};

}).constant('TRAINING_RECORD_API', {
	INDEX: 'api/trainingRecord/index',
	ALL_EMPLOYEES_CALENDAR: 'api/trainingRecord/allEmployeesCalendar',
	CALENDAR_EVENTS: 'api/trainingRecord/calendarEvents',
	BY_EMPLOYEE: 'api/trainingRecord/byEmployee',
	CREATE: 'api/trainingRecord/create',
	UPDATE: 'api/trainingRecord/update/',
	DELETE: 'api/trainingRecord/delete/'
});
